// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_login_email_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Your email`
};

const de_widget_login_email_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Deine E-Mail`
};

const es_widget_login_email_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Tu correo electrónico`
};

const fr_widget_login_email_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Votre email`
};

const fi_widget_login_email_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Sähköpostiosoitteesi`
};

const hi_widget_login_email_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `आपका ईमेल`
};

const ja_widget_login_email_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `あなたのメールアドレス`
};

const nl_widget_login_email_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Je e-mailadres`
};

const pt_widget_login_email_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Seu email`
};

const ro_widget_login_email_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Emailul tău`
};

const th_widget_login_email_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `อีเมลของคุณ`
};

const ur_widget_login_email_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `آپ کا ای میل`
};

const zh_hant1_widget_login_email_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `您的電子郵件`
};

const da_widget_login_email_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Din e-mail`
};

const it_widget_login_email_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `La tua email`
};

const vn_widget_login_email_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Email của bạn`
};

const ko_widget_login_email_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `귀하의 이메일`
};

const tr_widget_login_email_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `E-posta adresiniz`
};

const lv_widget_login_email_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Jūsu e-pasts`
};

const ar_widget_login_email_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `بريدك الإلكتروني`
};

const bs_widget_login_email_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Vaš email`
};

const sl_widget_login_email_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Vaš e-poštni naslov`
};

const id_widget_login_email_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Email Anda`
};

const sv_widget_login_email_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Din e-post`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_login_email_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_login_email_placeholder(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_login_email_placeholder", locale)
	if (locale === "en") return en_widget_login_email_placeholder(inputs)
	if (locale === "de") return de_widget_login_email_placeholder(inputs)
	if (locale === "es") return es_widget_login_email_placeholder(inputs)
	if (locale === "fr") return fr_widget_login_email_placeholder(inputs)
	if (locale === "fi") return fi_widget_login_email_placeholder(inputs)
	if (locale === "hi") return hi_widget_login_email_placeholder(inputs)
	if (locale === "ja") return ja_widget_login_email_placeholder(inputs)
	if (locale === "nl") return nl_widget_login_email_placeholder(inputs)
	if (locale === "pt") return pt_widget_login_email_placeholder(inputs)
	if (locale === "ro") return ro_widget_login_email_placeholder(inputs)
	if (locale === "th") return th_widget_login_email_placeholder(inputs)
	if (locale === "ur") return ur_widget_login_email_placeholder(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_login_email_placeholder(inputs)
	if (locale === "da") return da_widget_login_email_placeholder(inputs)
	if (locale === "it") return it_widget_login_email_placeholder(inputs)
	if (locale === "vn") return vn_widget_login_email_placeholder(inputs)
	if (locale === "ko") return ko_widget_login_email_placeholder(inputs)
	if (locale === "tr") return tr_widget_login_email_placeholder(inputs)
	if (locale === "lv") return lv_widget_login_email_placeholder(inputs)
	if (locale === "ar") return ar_widget_login_email_placeholder(inputs)
	if (locale === "bs") return bs_widget_login_email_placeholder(inputs)
	if (locale === "sl") return sl_widget_login_email_placeholder(inputs)
	if (locale === "id") return id_widget_login_email_placeholder(inputs)
	if (locale === "sv") return sv_widget_login_email_placeholder(inputs)
	return "widget_login_email_placeholder"
};